/** Значение ячейки расчёта затрат: строка, число или объект из Excel (richText и др.). */
export function formatCostCellValue(value) {
  if (value == null || value === '') return ''

  if (typeof value === 'object') {
    if (Array.isArray(value.richText)) {
      return value.richText.map(item => item.text || '').join(' ').trim()
    }
    if (value.text != null && String(value.text).trim() !== '') {
      return String(value.text).trim()
    }
    if (value.result != null && value.result !== '') {
      return String(value.result).trim()
    }
  }

  return String(value).trim()
}
